import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=7fcb68d9&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb68d9",
  null
  
)

export default component.exports